<template>
  <div class="wrap">

    <div style="text-align: center">
      <ion-button
        size="small"
        shape="round"
        :color="isLogin ? 'primary' : 'medium'"
        :disabled="!isLogin"
        fill="outline"
        @click="$router.push('/account/deposit/payment')"
      >
        Nạp
      </ion-button>
    </div>

    <div class="balance">
      Số dư:&nbsp;
      <span>
        {{ numberFormat(totalBalance) }} <GimoCoinSymbol></GimoCoinSymbol>
      </span>
    </div>

  </div>
  <div></div>
</template>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  .balance {
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      font-weight: bold;
    }
  }
}
</style>

<script>
import { IonButton } from '@ionic/vue'
import { defineComponent } from 'vue'
import authService from '@/services/auth'

import GimoCoinSymbol from './GimoCoinSymbol'

export default defineComponent({
  name: 'Balance',
  components: {
    GimoCoinSymbol,
    IonButton,
  },
  computed: {
    isLogin() {
      return !authService.anonymous;
    },
    totalBalance() {
      if (authService.anonymous) {
        return 0
      }
      return (
        this.$store.state.fsdb.customer.deposit +
        this.$store.state.fsdb.customer.bonus +
        this.$store.state.fsdb.customer.win
      )
    },
  },
  methods: {
    numberFormat(n) {
      return String(n).replace(/(.)(?=(\d{3})+$)/g, '$1.')
    },
  },
})
</script>
